<template>
  <v-breadcrumbs class="breadcrumbs">
    <v-breadcrumbs-item
      v-for="(crumb, index) in breadcrumbs"
      :key="index"
      @click="navigateTo(index)"
      class="breadcrumb-item"
    >
      <span>{{ crumb.text }}</span>
      <!-- Agrega un separador solo si no es el último elemento -->
      <template v-if="index < breadcrumbs.length - 1">
        <v-divider vertical class="divider" />
      </template>
    </v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  },
  methods: {
    navigateTo (index) {
      this.$emit('navigate', index)
    }
  }
}
</script>

<style scoped>
.breadcrumbs {
  background-color: #3949ab; /* Color de fondo claro */
  width: 100%;
  padding: 15px 20px; /* Espaciado interno */
  border-radius: 9px; /* Bordes redondeados */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra sutil */
}

.breadcrumb-item {
  cursor: pointer; /* Cambia el cursor para indicar clicabilidad */
  color: #ffffff; /* Color del texto */
  font-weight: 500; /* Peso de fuente ligeramente más pesado */
  transition: color 0.3s; /* Transición suave en el color */
}

.breadcrumb-item:hover {
  color: rgb(168, 167, 167); /* Color al pasar el mouse */
}

.divider {
  margin: 0 30px; /* Espaciado entre elementos */
  color: #020000; /* Color del separador */
}
</style>
